/**
 * Signed URLs of pictures stored in Azure Blob Storage. The SAS signature and
 * the storage host come with the user profile returned by /api/user/me.
 */
import { STORAGE_KEYS } from '@/shared/constants';
import { local } from '@/shared/lib/storage';

export type ImagePlatform = 'abc' | 'dms';

export const STORAGE = {
  AbcDiorBack: 'abcdior-back',
  DmsFrontAssets: 'dms-front-assets',
} as const;

export type StorageName = (typeof STORAGE)[keyof typeof STORAGE];

interface SignedUser {
  storageHost?: string;
  abcdiorBackKey?: string;
  dmsAssetsKey?: string;
}

const getSignature = (
  platform: ImagePlatform,
): { host: string | undefined; signature: string | undefined } => {
  const user = local.getJson<SignedUser>(STORAGE_KEYS.USER);
  if (!user) return { host: undefined, signature: undefined };
  return {
    host: user.storageHost,
    signature: platform === 'abc' ? user.abcdiorBackKey : user.dmsAssetsKey,
  };
};

export const getStorage = (assetUrl: string): StorageName | undefined => {
  if (assetUrl.includes(STORAGE.AbcDiorBack)) return STORAGE.AbcDiorBack;
  if (assetUrl.includes(STORAGE.DmsFrontAssets)) return STORAGE.DmsFrontAssets;
  return undefined;
};

export const getImage = (
  platform: ImagePlatform,
  storage: StorageName | undefined,
  path: string,
): string | null => {
  const { host, signature } = getSignature(platform);
  if (!signature || !host) return null;
  if (!storage) return `${host}${path}?${signature}`;
  return `${host}/${storage}${path}?${signature}`;
};
